import { FetchRequest, FetchResult } from "../types/fetcher";
import { enqueueLog, getPublicIP } from "../utils/logsHelper";

export const fetcherS3 = async <T>(outletCode: string, requests: FetchRequest[]): Promise<FetchResult<T>> => {
  if (!Array.isArray(requests)) throw new Error("Input must be an array of objects.");

  const fetchPromises = requests.map(async ({ variableName, alias }) => {
    const fullUrl = `${process.env.REACT_APP_AWS_URL}/POS/${outletCode}/main/${variableName}.json?_=${Date.now()}`;
    const ip = await getPublicIP();
    try {
      const res = await fetch(fullUrl);

      if (!res.ok) {
        await enqueueLog({
          url: fullUrl,
          subject: variableName,
          outlet_code: outletCode,
          request: "{}",
          ip,
          response_status: res.status,
          response: await res.text(),
          user_agent: navigator.userAgent,
        });
        return { key: alias, result: null };
      }

      const data = await res.json();
      // if (!data || !data.result) throw new Error(`Response does not contain 'result'.`);
      return { key: alias, result: data.result };
    } catch (error: any) {
      console.error(`Error fetching ${fullUrl}:`, error);

      await enqueueLog({
        url: fullUrl,
        subject: variableName,
        outlet_code: outletCode,
        request: "{}",
        ip,
        response_status: "FETCH_ERROR",
        response: error.message,
        user_agent: navigator.userAgent,
      });
      return { key: alias, result: null };
    }
  });

  const results = await Promise.all(fetchPromises);
  const resultObject: FetchResult<T> = { result: {} as T };
  results.forEach(({ key, result }) => ((resultObject.result as any)[key] = result));
  return resultObject;
};
